import { IntegrationAdapter, IntegrationConnectorId } from "./contracts";
import { syncGoogleWorkspaceSignals } from "./googleWorkspace";

/**
 * Google Calendar Integration Adapter 🛰️
 *
 * Role: Manages the "Play" timeline by detecting interview events and deadlines.
 * Automation: Post-interview debrief tasks and "Thank You" draft reminders.
 */
export class GoogleCalendarAdapter implements IntegrationAdapter {
  id: IntegrationConnectorId = "google_calendar";

  /**
   * Pulls relevant calendar events.
   */
  async pullSignals(opportunityId: string): Promise<string[]> {
    console.log(`[GoogleCalendar] Syncing timeline for play: ${opportunityId}`);
    const result = await syncGoogleWorkspaceSignals(this.id, opportunityId, 20);
    return result.signals;
  }

  /**
   * Detects if an event just finished to trigger a debrief prompt.
   */
  async getRecentFinishedEvents() {
    // Logic to find events that ended in the last hour
    return [];
  }
}

export const googleCalendarAdapter = new GoogleCalendarAdapter();
